export type Partner = {
  name: string
  kind: string
}

export const SPONSORS: Partner[] = [
  { name: 'Garage Fondada Auto', kind: 'Entretien automobile' },
  { name: 'Boulangerie Le Fournil d’Estrétefonds', kind: 'Artisan boulanger' },
  { name: 'Occitanie Bâtiment', kind: 'Construction & rénovation' },
  { name: 'Pharmacie du Parvis', kind: 'Santé' },
  { name: 'Intersport Nord Toulousain', kind: 'Équipement sportif' },
  { name: 'Assurances Lauret & Associés', kind: 'Courtage' },
]

export const INSTITUTIONS: Partner[] = [
  { name: 'Mairie de Castelnau d’Estrétefonds', kind: 'Collectivité — mise à disposition du dojo' },
  { name: 'Communauté de communes du Frontonnais', kind: 'Financeur public' },
  { name: 'Conseil départemental de la Haute-Garonne', kind: 'Subvention sport pour tous' },
  { name: 'Ligue Occitanie de Karaté', kind: 'Instance régionale' },
  { name: 'Comité départemental 31', kind: 'Instance départementale' },
  { name: 'Fédération Française de Karaté', kind: 'Affiliation fédérale' },
]

export const PATRONAGE = {
  intro:
    'Le mécénat permet au club de financer les déplacements en compétition, l’achat de matériel pédagogique et l’accès au karaté pour les familles les plus modestes.',
  levels: [
    {
      name: 'Soutien',
      amount: 'à partir de 250 €',
      benefits: ['Logo sur le site du club', 'Remerciements sur les réseaux sociaux'],
    },
    {
      name: 'Partenaire',
      amount: 'à partir de 750 €',
      benefits: ['Logo sur le site et les kimonos', 'Banderole au dojo', 'Invitations aux évènements du club'],
      featured: true,
    },
    {
      name: 'Mécène',
      amount: 'à partir de 1 500 €',
      benefits: ['Toutes les contreparties Partenaire', 'Encart sur les supports de compétition', 'Reçu fiscal (60 % de déduction)'],
    },
  ],
}
